import React, { forwardRef } from 'react';

import { DEFAULT_LOGO_HEIGHT, DEFAULT_LOGO_WIDTH } from '~/constants';

import brighteLogo from '../../public/brighte-logo.svg';

// We're forcing these to be of type `number`
type BrighteLogoProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  height?: number;
  width?: number;
};

const BrighteLogo = forwardRef<HTMLImageElement, BrighteLogoProps>(
  ({ height = DEFAULT_LOGO_HEIGHT, width = DEFAULT_LOGO_WIDTH, ...props }, ref) => (
    <img ref={ref} src={brighteLogo} alt="Brighte logo" height={height} width={width} {...props} />
  ),
);

BrighteLogo.displayName = 'BrighteLogo';

export { BrighteLogo };
